module.exports = __webpack_public_path__ + "static/media/head4.6c6826ed.jpg";